import React from "react";
import { MAP_GLOBAL_STATES } from "globalStore/globalStore";
import { useHookstate } from "@hookstate/core";
import FBReports from "./F&BReports";
import FBSettings from "./FBSettings/FBSettings";
import { Orders } from "./Orders";
import { Tree } from "./FBSettings/sortedData";

export const FoodAndBeverages = () => {
  const { mapSideNavTabState } = useHookstate(MAP_GLOBAL_STATES);
  
  switch (mapSideNavTabState.get()) {
    case "Reports":
      return <FBReports />;
    case "Settings":
      return <FBSettings />;
    case "Sort":
      return <Tree />;
    case "Orders":
      return <Orders />;
    default:
      return<></>;
  }
};
